/*!
 * Zimshy Build-Your-Routine page. Needs assets/zimshy-core.js (window.ZP).
 * One product per step (radio), live sidebar, free gift unlock (choose 1), order discount progress,
 * add everything to the cart in one request.
 */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function init() {
    var root = $('[data-zp-routine-builder]');
    var ZP = window.ZP;
    if (!root || root.__zrb || !ZP) return;
    root.__zrb = true;

    var C = ZP.config || {}, G = C.gift || {}, D = C.disc || {};
    var money = ZP.money, esc = ZP.esc;
    var steps = $$('.zrb-step', root);
    var panels = $$('.zrb-panel', root);
    var tabs = $$('.zrb-tab', root);
    var side = $('.zrb-side', root);
    function routineOf(st) { return Number(st.getAttribute('data-routine')) || 0; }
    function panelInfo(ri) {
      var pn = panels.filter(function (p) { return Number(p.getAttribute('data-panel')) === ri; })[0];
      return { name: pn ? pn.getAttribute('data-rname') : '', emoji: pn ? pn.getAttribute('data-remoji') : '' };
    }
    function activate(ri, focus) {
      if (!tabs.length) return;
      panels.forEach(function (p) { p.hidden = Number(p.getAttribute('data-panel')) !== ri; });
      tabs.forEach(function (t) {
        var on = Number(t.getAttribute('data-tab')) === ri;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      var t = tabs.filter(function (x) { return Number(x.getAttribute('data-tab')) === ri; })[0];
      if (t && window.history && history.replaceState) { try { history.replaceState(null, '', '#' + t.getAttribute('data-hash')); } catch (e) {} }
      // carousels inside a panel that was hidden need to re-measure
      setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 30);
    }
    function missingSteps() {
      var active = {};
      Object.keys(sel).forEach(function (k) { if (steps[k]) active[routineOf(steps[k])] = true; });
      return steps.filter(function (st, si) {
        return !st.hidden && st.getAttribute('data-required') === 'true' && !sel[si] && active[routineOf(st)];
      });
    }
    var el = {
      list: $('[data-zrb-list]', root), empty: $('[data-zrb-empty]', root),
      total: $('[data-zrb-total]', root), totalBar: $('[data-zrb-total-bar]', root), count: $('[data-zrb-count]', root),
      saveRow: $('[data-zrb-save-row]', root), save: $('[data-zrb-save]', root),
      cartRow: $('[data-zrb-cart-row]', root), cart: $('[data-zrb-cart]', root),
      offers: $('[data-zrb-offers]', root), msg: $('[data-zrb-msg]', root),
      add: $('[data-zrb-add]', root), ck: $('[data-zrb-checkout]', root)
    };
    var KEY = 'zrb_' + location.pathname;
    var sel = {};          // step index -> { pid, vid }
    var giftChoice = null;
    var busy = false;

    function variantsOf(card) {
      if (!card.__v) { try { card.__v = JSON.parse(card.getAttribute('data-variants') || '[]'); } catch (e) { card.__v = []; } }
      return card.__v;
    }
    function currentVariant(card) {
      var vs = variantsOf(card), s = $('.zrb-card__sel', card), id = s ? String(s.value) : null, v = null;
      vs.forEach(function (x) { if (id && String(x.id) === id) v = x; });
      if (!v) vs.forEach(function (x) { if (!v && x.a) v = x; });
      return v || vs[0] || null;
    }
    function cardOf(si, pid) { return steps[si] ? $('.zrb-card[data-pid="' + pid + '"]', steps[si]) : null; }

    function syncCardPrice(card) {
      var v = currentVariant(card);
      if (!v) return;
      var now = $('[data-now]', card), was = $('[data-was]', card);
      if (now) now.textContent = money(v.p);
      if (was) was.textContent = v.c > v.p ? money(v.c) : '';
    }

    function save() {
      try { sessionStorage.setItem(KEY, JSON.stringify(sel)); } catch (e) {}
    }

    function pick(si, card, scroll) {
      var v = currentVariant(card);
      if (!v || !v.a) {
        setMsg('This option is sold out. Please choose another.');
        var inp0 = $('.zrb-card__in', card); if (inp0) inp0.checked = false;
        return;
      }
      sel[si] = { pid: card.getAttribute('data-pid'), vid: String(v.id) };
      var inp = $('.zrb-card__in', card);
      if (inp && !inp.checked) inp.checked = true;
      setMsg('');
      save();
      render();
      if (scroll && window.innerWidth > 0) {
        var next = steps[si + 1];
        if (next && !next.hidden && routineOf(next) === routineOf(steps[si]) && sel[si + 1] == null) {
          var r = next.getBoundingClientRect();
          if (r.top > window.innerHeight * 0.75) setTimeout(function () { next.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250);
        }
      }
    }
    function clear(si) {
      delete sel[si];
      $$('.zrb-card__in', steps[si]).forEach(function (i) { i.checked = false; });
      save();
      render();
    }

    function setMsg(t) { if (el.msg) el.msg.textContent = t || ''; }

    function items() {
      var out = [];
      steps.forEach(function (st, si) {
        var s = sel[si];
        if (!s) return;
        var card = cardOf(si, s.pid);
        if (!card) return;
        var v = null;
        variantsOf(card).forEach(function (x) { if (String(x.id) === String(s.vid)) v = x; });
        if (!v) return;
        out.push({ si: si, ri: routineOf(st), step: st.getAttribute('data-title'), title: card.getAttribute('data-title'), img: card.getAttribute('data-img'), v: v, multi: variantsOf(card).length > 1 });
      });
      return out;
    }

    function render() {
      var list = items();
      var total = 0, compare = 0;
      list.forEach(function (it) { total += it.v.p; compare += Math.max(it.v.c || 0, it.v.p); });

      // cards + steps + chips
      steps.forEach(function (st, si) {
        var s = sel[si];
        $$('.zrb-card', st).forEach(function (c) { c.classList.toggle('is-on', !!s && c.getAttribute('data-pid') === s.pid); });
        st.classList.toggle('is-done', !!s);
        var clr = $('[data-clear]', st);
        if (clr) clr.hidden = !s;
        var tl = $('[data-tl="' + si + '"]', root);
        if (tl) tl.classList.toggle('is-done', !!s);
      });
      var perR = {};
      list.forEach(function (it) { perR[it.ri] = (perR[it.ri] || 0) + 1; });
      $$('[data-tab-count]', root).forEach(function (b) {
        var n = perR[Number(b.getAttribute('data-tab-count'))] || 0;
        b.hidden = !n; b.textContent = n;
      });

      // sidebar list
      var prevKeys = el.list.__keys || {};
      var keys = {};
      var grouped = panels.length > 1;
      var lastR = null;
      var listHtml = list.map(function (it) {
        var k = it.si + ':' + it.v.id; keys[k] = 1;
        var head = '';
        if (grouped && it.ri !== lastR) {
          lastR = it.ri;
          var info = panelInfo(it.ri);
          head = '<li class="zrb-side__grp">' + esc(info.emoji) + ' ' + esc(info.name) + '<b>' + perR[it.ri] + '</b></li>';
        }
        return head + '<li class="zrb-side__item' + (prevKeys[k] ? ' is-old' : '') + '">' +
          (it.img ? '<img src="' + esc(it.img) + '" width="46" height="46" alt="" loading="lazy">' : '') +
          '<span class="zrb-side__it"><span class="zrb-side__step">' + esc(it.step) + '</span><span class="zrb-side__name">' + esc(it.title) + '</span>' +
          (it.multi ? '<span class="zrb-side__var">' + esc(it.v.t) + '</span>' : '') + '</span>' +
          '<span class="zrb-side__pr">' + money(it.v.p) + '</span>' +
          '<button type="button" class="zrb-side__rm" data-rm="' + it.si + '" aria-label="Remove ' + esc(it.title) + '">&times;</button></li>';
      }).join('');
      var sig = Object.keys(keys).join('|');
      if (el.list.__sig !== sig) { el.list.innerHTML = listHtml; el.list.__sig = sig; }
      el.list.__keys = keys;
      el.empty.hidden = list.length > 0;
      el.total.textContent = money(total);
      el.totalBar.textContent = money(total);
      el.count.textContent = list.length;
      var saving = compare - total;
      el.saveRow.hidden = saving <= 0;
      el.save.textContent = money(saving);

      var cartSub = ZP.subtotal(ZP.state.cart);
      el.cartRow.hidden = cartSub <= 0;
      el.cart.textContent = money(cartSub);

      var missing = missingSteps();
      var can = list.length > 0 && !busy;
      el.add.disabled = !can;
      if (el.ck) el.ck.disabled = !can;
      el.add.title = missing.length ? 'Pick: ' + missing.map(function (m) { return m.getAttribute('data-title'); }).join(', ') : '';

      renderOffers(total + cartSub);
    }

    function renderOffers(sub) {
      var html = '';
      var ui = ZP.ui;
      var gifts = ZP.gifts();
      if (G.enabled && gifts.length) {
        var thr = Number(G.threshold) || 0, ok = sub >= thr;
        var inCart = (ZP.state.cart.items || []).filter(ZP.isGiftLine)[0];
        if (!giftChoice) {
          var saved = ZP.store.get('choice');
          giftChoice = inCart ? String(inCart.variant_id) : (saved && gifts.some(function (g) { return String(g.vid) === saved; }) ? saved : (G.preselect ? String(gifts[0].vid) : null));
        }
        var msg = ok ? esc(G.unlocked) : ui.fill(esc(G.locked), { amount: '<b>' + money(thr - sub) + '</b>' });
        html += '<div class="zp-offer zp-offer--gift' + (ok ? ' is-ok' : '') + '"><div class="zp-offer__row"><span class="zp-offer__ic">' + ui.GIFT_SVG + '</span><span class="zp-offer__msg">' + msg + '</span></div>' +
          (ok ? '<p class="zp-offer__h">' + esc(G.heading) + '</p>' : ui.bar(sub / thr * 100)) +
          ui.giftOptions('zrb-gift', giftChoice || '', !ok, false) + '</div>';
      }
      if (D.enabled && Number(D.threshold) > 0) {
        var dthr = Number(D.threshold), dok = sub >= dthr, pct = Number(D.percent) || 0;
        var dmsg = dok
          ? ui.fill(esc(D.unlocked), { percent: pct, saving: '<b>' + money(Math.round(sub * pct / 100)) + '</b>' })
          : ui.fill(esc(D.locked), { amount: '<b>' + money(dthr - sub) + '</b>', percent: pct });
        html += '<div class="zp-offer zp-offer--disc' + (dok ? ' is-ok' : '') + '"><div class="zp-offer__row"><span class="zp-offer__ic">' + ui.TAG_SVG + '</span><span class="zp-offer__msg">' + dmsg + '</span></div>' +
          (dok ? '' : ui.bar(sub / dthr * 100)) + '</div>';
      }
      if (el.offers.__h !== html) { el.offers.innerHTML = html; el.offers.__h = html; }
    }

    function giftEligible() {
      var total = 0;
      items().forEach(function (it) { total += it.v.p; });
      return G.enabled && ZP.gifts().length && (total + ZP.subtotal(ZP.state.cart)) >= (Number(G.threshold) || 0);
    }

    function addAll(mode) {
      if (busy) return;
      var list = items();
      var missing = missingSteps();
      if (missing.length) {
        setMsg('Please choose: ' + missing.map(function (m) { return (panels.length > 1 ? panelInfo(routineOf(m)).name + ' - ' : '') + m.getAttribute('data-title'); }).join(', '));
        activate(routineOf(missing[0]));
        closeSheet();
        setTimeout(function () { missing[0].scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 60);
        return;
      }
      if (!list.length) { setMsg('Pick at least one product.'); return; }
      busy = true;
      setMsg('');
      var btn = mode === 'checkout' ? el.ck : el.add;
      btn.classList.add('is-busy');
      el.add.disabled = true; if (el.ck) el.ck.disabled = true;

      if (giftEligible() && giftChoice) ZP.setPending(giftChoice);
      ZP.addItems(list.map(function (it) { return { id: Number(it.v.id), quantity: 1 }; }))
        .then(function () { return ZP.reconcile(); })
        .then(function (cart) {
          busy = false;
          btn.classList.remove('is-busy');
          var action = mode === 'checkout' ? 'checkout' : (root.getAttribute('data-action') || 'drawer');
          if (action === 'checkout') { ZP.goCheckout(cart); return; }
          if (action === 'cart') { window.location.href = (C.root || '/') + 'cart'; return; }
          ZP.toast('Your routine is in the cart', 'ok');
          ZP.refreshTheme();
          closeSheet();
          ZP.openCart();
          render();
        })
        .catch(function (err) {
          busy = false;
          btn.classList.remove('is-busy');
          ZP.setPending(null);
          setMsg(err && err.message ? err.message : 'Could not add your routine. Please try again.');
          render();
        });
    }

    function openSheet() { side.classList.add('is-open'); root.classList.add('is-sheet'); document.documentElement.classList.add('zp-noscroll'); $$('[data-zrb-toggle]', root)[0].setAttribute('aria-expanded', 'true'); }
    function closeSheet() { side.classList.remove('is-open'); root.classList.remove('is-sheet'); document.documentElement.classList.remove('zp-noscroll'); var t = $$('[data-zrb-toggle]', root)[0]; if (t) t.setAttribute('aria-expanded', 'false'); }

    // events
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      var card = t.closest('.zrb-card');
      var st = t.closest('.zrb-step');
      var si = st ? Number(st.getAttribute('data-step')) : -1;
      if (t.classList.contains('zrb-card__in') && card) { pick(si, card, true); return; }
      if (t.classList.contains('zrb-card__sel') && card) {
        syncCardPrice(card);
        pick(si, card, false);
        return;
      }
      if (t.name === 'zrb-gift') {
        giftChoice = String(t.value);
        ZP.store.set('choice', giftChoice);
        ZP.store.del('declined');
        render();
      }
    });
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var rm = t.closest('[data-rm]');
      if (rm) { clear(Number(rm.getAttribute('data-rm'))); return; }
      var cl = t.closest('[data-clear]');
      if (cl) { clear(Number(cl.getAttribute('data-clear'))); return; }
      if (t.closest('[data-zrb-add]')) { addAll('cart'); return; }
      if (t.closest('[data-zrb-checkout]')) { addAll('checkout'); return; }
      if (t.closest('[data-zrb-toggle]')) { if (side.classList.contains('is-open')) closeSheet(); else openSheet(); return; }
      var tab = t.closest('.zrb-tab');
      if (tab) { activate(Number(tab.getAttribute('data-tab'))); return; }
      var tl = t.closest('[data-tl]');
      if (tl) {
        e.preventDefault();
        var target = steps[Number(tl.getAttribute('data-tl'))];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (t.closest('.zrb-card__sel')) e.stopPropagation();
    });
    // arrow keys between tabs
    root.addEventListener('keydown', function (e) {
      var tab = e.target && e.target.closest && e.target.closest('.zrb-tab');
      if (!tab || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var i = Number(tab.getAttribute('data-tab')), n = tabs.length;
      activate((i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n, true);
      e.preventDefault();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && side.classList.contains('is-open')) closeSheet(); });
    document.addEventListener('zp:cart', function () { render(); });

    // restore the previous selection in this tab
    try {
      var saved = JSON.parse(sessionStorage.getItem(KEY) || '{}');
      Object.keys(saved).forEach(function (k) {
        var si = Number(k), s = saved[k], card = s && cardOf(si, s.pid);
        if (!card) return;
        var sl = $('.zrb-card__sel', card);
        if (sl && s.vid) { sl.value = s.vid; syncCardPrice(card); }
        var v = currentVariant(card);
        if (v && v.a) { sel[si] = { pid: s.pid, vid: String(v.id) }; var inp = $('.zrb-card__in', card); if (inp) inp.checked = true; }
      });
    } catch (e) {}
    // open the routine named in the link (#evening-routine), else the first one
    var start = 0;
    var h = (location.hash || '').replace('#', '');
    tabs.forEach(function (t) { if (h && t.getAttribute('data-hash') === h) start = Number(t.getAttribute('data-tab')); });
    if (tabs.length) activate(start);
    render();
  }

  // zimshy-core.js is deferred too and may run after this file: wait for it.
  if (window.ZP && window.ZP.__ready && document.readyState === 'complete') init();
  else {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  }
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
